import { render, staticRenderFns } from "./KPICardIndividual.vue?vue&type=template&id=622bf64d&scoped=true"
import script from "./KPICardIndividual.vue?vue&type=script&lang=js"
export * from "./KPICardIndividual.vue?vue&type=script&lang=js"
import style0 from "./KPICardIndividual.vue?vue&type=style&index=0&id=622bf64d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622bf64d",
  null
  
)

export default component.exports